import { parsePhoneNumber } from "react-phone-number-input";

export function toE164PhoneNumber(phoneNumber, countryCode = "TR") {
  const raw = (phoneNumber || "").trim();
  if (!raw || raw === "-") return "";

  const cc = (countryCode || "TR").toUpperCase();
  if (cc === "TR") {
    return raw.startsWith("+") ? raw : `+90${raw}`;
  }
  return raw.startsWith("+") ? raw : `+${raw}`;
}

export function formatPhoneNumberForDisplay(phoneNumber, countryCode = "TR") {
  const raw = (phoneNumber || "").trim();
  if (!raw || raw === "-") return "";

  const parsed = parsePhoneNumber(toE164PhoneNumber(raw, countryCode));
  return parsed ? parsed.formatInternational() : raw;
}

export function formatUserNameWithPhone(user) {
  if (!user?.name) return "";
  if (!user.phonenumber) return user.name;
  return `${user.name} (${formatPhoneNumberForDisplay(user.phonenumber, user.countryCode)})`;
}
